import React from "react";

const educationContent = [
  {
    year: "2018-2020",
    degree: "Bachelor en ingénierie du web",
    institute: "HIMI (Higher International Management Institut) Groupe INSIM",
    
  },
  {
    year: "2015-2018",
    degree: "BTS en Base de Données",
    institute: "INSFP (Institut Spécialisé Dans la Formation Professionnelle - Ex CFA)",
    
  },
  
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <i className="fa fa-briefcase"></i>
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
